"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ActorQueryOperation_1 = require("./ActorQueryOperation");
/**
 * A base implementation for query operation actors for a specific operation type.
 */


var ActorQueryOperationTyped =
/*#__PURE__*/
function (_ActorQueryOperation_) {
  _inherits(ActorQueryOperationTyped, _ActorQueryOperation_);

  function ActorQueryOperationTyped(args, operationName) {
    var _this;

    _classCallCheck(this, ActorQueryOperationTyped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationTyped).call(this, Object.assign({}, args, {
      operationName: operationName
    })));

    if (!_this.operationName) {
      throw new Error('A valid "operationName" argument must be provided.');
    }

    return _this;
  }

  _createClass(ActorQueryOperationTyped, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var operation;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (action.operation) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Missing field \'operation\' in the query operation action: ' + require('util').inspect(action));

              case 2:
                if (!(action.operation.type !== this.operationName)) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Actor ' + this.name + ' only supports ' + this.operationName + ' operations, but got ' + action.operation.type);

              case 4:
                operation = action.operation;
                return _context.abrupt("return", this.testOperation(operation, action.context));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var operation, output;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                operation = action.operation;
                _context2.next = 3;
                return this.runOperation(operation, action.context);

              case 3:
                output = _context2.sent;

                if (output.metadata) {
                  output.metadata = ActorQueryOperation_1.ActorQueryOperation.cachifyMetadata(output.metadata);
                }

                return _context2.abrupt("return", output);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorQueryOperationTyped;
}(ActorQueryOperation_1.ActorQueryOperation);

exports.ActorQueryOperationTyped = ActorQueryOperationTyped;